<template>
    <v-toolbar dark color="primary">
        <router-link to="/">
            <v-toolbar-side-icon>
                <v-img :src="require('../assets/favicon.png')"></v-img>
            </v-toolbar-side-icon>
        </router-link>
        <v-spacer></v-spacer>
            <div v-if="showLangs">
                <v-btn flat
                       v-for="language in languageList"
                       :key="language"
                       :to="`/translations/${language}`"
                >
                    {{ language }}
                </v-btn>
            </div>
        <v-spacer></v-spacer>
        <v-btn icon to="/dashboard">
            <v-icon>dashboard</v-icon>
        </v-btn>
        <v-btn icon @click="exit">
            <v-icon>exit_to_app</v-icon>
        </v-btn>
    </v-toolbar>
</template>

<script>

import { onLogout } from "../vue-apollo"

export default {
    props: {
        showLangs: {
            type: Boolean,
            default: true
        },
        languageList: {
            type: Array,
            default: () => []
        }
    },
    data () {
        return {
            activeLanguage: this.$route.params.language
        }
    },
    methods: {
        exit () {
            onLogout(this.$apollo.provider.defaultClient)
            this.$router.replace("/welcome")
        }
    }
}

</script>
